export default function getPageTitle(siteName) {
  return siteName.toUpperCase() === "CAMBRIDGE OPEN ENGAGE"
    ? "Cambridge Open Engage"
    : `${siteName} | Cambridge Open Engage`;
}
